import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Invoked when the user selects 1+ doors for mass change, then clicks the Change button
export default class extends Controller {
  static values = {
    url: String,
    formGroup: String
  }
  
  // Need mass_change url (which includes question_id) and array of door id's
  // Find selected doors by using tgt which is the form group with checkboxes
  // of selected doors
  load(event) {
    // parse params or object and encodes/escapes 
    let params = new URLSearchParams()

    // Find checked doors based on the form group
    const parentElement = document.getElementById('mass-change-table');
    const groupCheckboxes = parentElement.querySelectorAll('input[type="checkbox"][data-form-group="' + this.formGroupValue + '"]');
    const allChecked = Array.from(groupCheckboxes)
                            .filter(checkbox => checkbox.checked)
                            .map(checkbox => checkbox.getAttribute("data-door"));

    params.append("doors", allChecked)
    params.append("formGroup", this.formGroupValue)

    get(`${this.urlValue}?${params}`, {
      responseKind: "turbo-stream"
    })
  }
}
